module.exports = __webpack_public_path__ + "234852cc821cd1f574febbe584a1e214.png";